import React, { useEffect, useState } from "react"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableContainer from "@mui/material/TableContainer"
import TablePagination from "@mui/material/TablePagination"
import Paper from "@mui/material/Paper"
import CustomTableHeader from "./CustomTableHeader"
import CustomTableToolbar from "./CustomTableToolbar"
import CustomTableRow from "./CustomTableRow"
import { createTheme } from "@mui/material"
import { makeStyles } from "@material-ui/core"
import GeneralSwipeableView from "../ContentContainers/GeneralSwipeableView"

const theme_bp = createTheme({
  breakpoints: {
    values: {
      sm: 750,
    },
  },
})

const useStyles = makeStyles({
  filterRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  bigTable: {
    [theme_bp.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  smallTable: {
    [theme_bp.breakpoints.up("sm")]: {
      display: "none",
    },
    [theme_bp.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  smallTableRows: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
  },
})
export default function CustomTableContainer(props) {
  const {
    defaultOrder,
    defaultOrderHeader,
    headers,
    rowData,
    paginationOptions,
    defaultPaginationOption,
    clickAction,
    filterManager,
    getMobileElement,
    swipeable,
    showArchived,
    checkBoxes,
    AdditionalToolbar,
    actions,
    actionsHistory,
    setActionsHistory,
    selected,
    setSelected,
    selectAll,
    setSelectAll,
    UnsavedChangesSnackbar,
    isSelected,
    ActionsButtons,
  } = props

  const [order, setOrder] = useState(defaultOrder) // asc or desc
  const [orderBy, setOrderBy] = useState(defaultOrderHeader)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(defaultPaginationOption)
  const [visibleRows, setVisibleRows] = useState([])
  const [filteredRows, setFilteredRows] = useState([])
  const [visibleHeaders, setVisibleHeaders] = useState(headers)

  const classes = useStyles()

  const updateHeaders = (newHeaders) => {
    setVisibleHeaders(newHeaders)
  }

  const handleRequestSort = (_, property) => {
    const isAsc = orderBy === property && order === "asc"
    setOrder(isAsc ? "desc" : "asc")
    setOrderBy(property)
    setPage(0)
  }

  const handleChangePage = (_, newPage) => {
    if (selectAll) {
      setSelectAll(false)
    }
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleSelectAllClick = (event) => {
    event.stopPropagation()
    setSelectAll(!selectAll)
    if (event.target.checked) {
      const newSelected = visibleRows.map((n) => n.id).filter((id) => !selected.includes(id))
      setSelected([...selected, ...newSelected])
      return
    }
    setSelected(selected.filter((id) => !visibleRows.map((n) => n.id).includes(id)))
  }

  const handleOnSelectClick = (event, id) => {
    event.stopPropagation()
    const selectedIndex = selected.indexOf(id)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }
    setSelected(newSelected)
  }

  useEffect(() => {
    setOrderBy(defaultOrderHeader)
  }, [defaultOrderHeader])

  useEffect(() => {
    setVisibleHeaders(headers)
  }, [headers])

  useEffect(() => {
    if (filteredRows) {
      setVisibleRows(
        filteredRows
          .sort(filterManager.getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
      )
    }
  }, [order, orderBy, page, rowsPerPage, filteredRows, filterManager.getComparator])

  useEffect(() => {
    if (actions) {
      localStorage.setItem("actions", JSON.stringify(actions))

      if (actionsHistory && actionsHistory.length === 0 && actions && actions.length > 0) {
        setActionsHistory([actions])
      }
    }
  }, [actions, actionsHistory, setActionsHistory])

  return (
    <div>
      <Paper sx={{ width: "100%" }}>
        <CustomTableToolbar
          headers={visibleHeaders}
          rowData={rowData}
          filterManager={filterManager}
          setFilteredRowData={setFilteredRows}
          filteredRowData={filteredRows}
          AdditionalToolbar={AdditionalToolbar}
          showArchived={showArchived}
        />
        <div className={classes.bigTable}>
          <TableContainer>
            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size={"small"}>
              <CustomTableHeader
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                headers={visibleHeaders}
                updateHeaders={updateHeaders}
                onSelectAllClick={handleSelectAllClick}
                selectAll={selectAll}
                checkBoxes={checkBoxes}
              />
              <TableBody>
                {visibleRows.map((row) => (
                  <CustomTableRow
                    row={row}
                    key={row.id}
                    headers={visibleHeaders}
                    clickAction={clickAction}
                    isSelected={isSelected}
                    onSelectClick={handleOnSelectClick}
                    checkBoxes={checkBoxes}
                    ActionsButtons={ActionsButtons}
                    filterManager={filterManager}
                  />
                ))}
              </TableBody>
            </Table>
            {UnsavedChangesSnackbar}
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={paginationOptions}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            showFirstButton={true}
            showLastButton={true}
          />
        </div>
        {getMobileElement && (
          <div className={classes.smallTable}>
            {swipeable ? (
              <GeneralSwipeableView content={filteredRows.map((row) => getMobileElement(row))} />
            ) : (
              <>
                <div className={classes.smallTableRows}>
                  {visibleRows.map((row) => getMobileElement(row))}
                </div>
                <TablePagination
                  rowsPerPageOptions={[defaultPaginationOption]}
                  component="div"
                  count={filteredRows.length}
                  rowsPerPage={defaultPaginationOption}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </>
            )}
          </div>
        )}
      </Paper>
    </div>
  )
}
